<div class="tipside-with-modal-container" [ngClass]="styleType">
  <div class="header-container">
    <p>{{ 'steps.tipsideWithModal.data_sharing' | translate }}</p>
    <span nz-icon nzType="info-circle" nzTheme="outline"></span>
  </div>
  <div class="content-container">
    <nz-badge [ngClass]="badgeStatus" [nzText]="'steps.tipsideWithModal.' + badgeStatus | translate" [nzStatus]="badgeStatus"></nz-badge>
    <div>
      <a role="button" tabindex="0" (click)="openModifyModal()" (keydown.enter)="openModifyModal()" (keydown.space)="openModifyModal(); $event.preventDefault()">{{ 'steps.tipsideWithModal.modify' | translate }}</a>
      @if (styleType === 'extended') {
        <img src="/public/assets/images/icon-right-blue.svg" alt="arrow right icon" />
      }
    </div>
  </div>
</div>
